<template>
    <politiqueConfidentialite />
</template>

<script>
import politiqueConfidentialite from '@/components/politique-de-confidentialite.vue';

export default {
  components: {
    politiqueConfidentialite
  }
}
</script>
